import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

export const Header = styled.div`
  display: flex;
  gap: 1.2rem;
`

export const ProductTitleLink = styled.a`
  display: block;

  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const ImageWrapper = styled.div`
  height: 20vh;
  min-height: 17rem;
  max-height: 20rem;
  aspect-ratio: 4/5;
`

export const LoadingImage = styled(Skeleton)`
  height: 100%;
  display: block;
`

export const PriceLine = styled.div`
  display: flex;
  gap: 1rem;
`

export const EmptyImage = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.colors.skeleton.baseColor};
`

export const ProductImage = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;

  .safari-lower-than-15 & {
    max-width: 40vw;
    object-fit: contain;
  }
`

export const ItemQuantity = styled.div`
  display: flex;
  align-items: center;
`

export const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CurrentQuantity = styled.div`
  min-width: 4rem;
  padding: 1.2rem 1rem;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0;

  .product-type {
    font-size: 1.2rem;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.hover};
  }
`

export const DeleteButton = styled.button`
  padding: 1rem;
  margin-right: -1.2rem;
  background: none;
  border: none;

  &:hover {
    background: none;
  }
`

export const ProductDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-top: 0.5rem;
`

export const Button = styled.button`
  display: inline-flex;
  padding: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.hover};
  border: none;

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:active {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.disabled};
    background: ${({ theme }) => theme.colors.disabled};
    color: ${({ theme }) => theme.colors.text.secondary};
    cursor: not-allowed;
  }
`
